export interface Navigation {
    width: number;
    padding: {
        horizontal: number;
    };
    header: {
        bottom: number;
    };
}

const navigation: Navigation = {
    width: 250,
    padding: {
        horizontal: 24
    },
    header: {
        bottom: 8
    }
};

export default navigation;
